import { render, staticRenderFns } from "./IncomeDetails.vue?vue&type=template&id=fa618b72&scoped=true&"
import script from "./IncomeDetails.vue?vue&type=script&lang=js&"
export * from "./IncomeDetails.vue?vue&type=script&lang=js&"
import style0 from "./IncomeDetails.vue?vue&type=style&index=0&id=fa618b72&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa618b72",
  null
  
)

export default component.exports